export default __webpack_public_path__ + "static/media/Logo_Mustang.18a727d8.png";